export default function SUM() {
  return (
    <div className="p-4">
      <h1>SUM</h1>
    </div>
  );
}
